const dataSource = (body: object, dataName: string): string | null => {
  const data = body[dataName];
  const dataIsEmpty = data == null || (Array.isArray(data) && data.length === 0);
  return dataIsEmpty ? null : body[`${dataName}DataSource`];
};

export default dataSource;
